import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import BreadcrumbPath from '../common/BreadcrumbPath';
import config from '../../config';

const useStyles = makeStyles(theme => ({
  taxonomyPaper: {
    padding: '3px'
  },
  metricTitle: {
    paddingLeft: 15,
    paddingTop: 15
  }
}));

const MetricDetails = props => {
  const classes = useStyles();
  const metric = props.metric;
  const TAXONOMY_QUERY = gql`
    query getTaxonomyQuery($metricId: String) {
      taxonomyPaths(metricId: $metricId)
    }
  `;
  const taxonomyPathsQueryResult = useQuery(TAXONOMY_QUERY, { variables: { metricId: metric.id } });

  return (
    <>
      <Typography className={classes.metricTitle} variant='h4' gutterBottom>
        {metric.name}
      </Typography>
      <List>
        {metric.toplineMetric && metric.toplineMetric.name && (
          <ListItem>
            <ListItemText primary='Topline Metric' secondary={metric.toplineMetric.name} />
          </ListItem>
        )}
        {metric.metricCategory && metric.metricCategory.name && (
          <ListItem>
            <ListItemText primary='Metric Categeory' secondary={metric.metricCategory.name} />
          </ListItem>
        )}
        {metric.metricGroup && metric.metricGroup.name && (
          <ListItem>
            <ListItemText primary='Metric Group' secondary={metric.metricGroup.name} />
          </ListItem>
        )}
        {metric.demographic && metric.demographic.name && (
          <ListItem>
            <ListItemText primary='Demographic' secondary={metric.demographic.name} />
          </ListItem>
        )}
        {metric.forecastType && metric.forecastType.name && (
          <ListItem>
            <ListItemText primary='Forecast Type' secondary={metric.forecastType.name} />
          </ListItem>
        )}
        {metric.penetration && metric.penetration.name && (
          <ListItem>
            <ListItemText primary='Penetration' secondary={metric.penetration.name.replace('(', '').replace(')', '')} />
          </ListItem>
        )}
        {metric.package && metric.package.name && (
          <ListItem>
            <ListItemText primary='Package' secondary={metric.package.name} />
          </ListItem>
        )}
        {taxonomyPathsQueryResult &&
          taxonomyPathsQueryResult.data &&
          taxonomyPathsQueryResult.data.taxonomyPaths &&
          taxonomyPathsQueryResult.data.taxonomyPaths.length > 0 && (
            <ListItem>
              <ListItemText
                component='span'
                primary='Taxonomic Classification'
                disableTypography
                secondary={
                  <List>
                    {taxonomyPathsQueryResult.data.taxonomyPaths.map((tp, i) => (
                      <ListItem key={i}>
                        <Paper className={classes.taxonomyPaper}>
                          <BreadcrumbPath
                            path={tp.map(tp => ({ name: tp.split(';')[0], id: config.enableTaxonomyPage ? tp.split(';')[1] : null }))}
                            baseUrl='/taxonomy/'
                          />
                        </Paper>
                      </ListItem>
                    ))}
                  </List>
                }
              />
            </ListItem>
          )}
      </List>
    </>
  );
};

export default props => (props.metric ? <MetricDetails metric={props.metric} /> : null);
